<template>
    <div id="app">
        <ToastManager />
        <router-view />
    </div>
</template>

<script>
import ToastManager from '@/components/toast/ToastManager'
export default {
    name: 'App',
    components: {
        ToastManager,
    },
}
</script>

<style lang="sass">
@import "./assets/css/main.sass"
</style>
